var _ = require('lodash');
var Time = require('./time.js'); 

function Task(data)
{
    this.data = _.cloneDeep(data);
}

Task.prototype.getTaskId = function()
{
    return this.data.id;
}

Task.prototype.getOrganizationAccountId = function()
{
    return this.data.account_id;
}

Task.prototype.getType = function()
{
    return this.data.details.type;
}

Task.prototype.getCustomerName = function()
{
    return this.data.details.consumer_name;
}

Task.prototype.getCustomerEndpoint = function()
{
    return this.data.details.consumer_endpoint;
}

Task.prototype.getMessageFromCustomer = function(default_value)
{
    let ret = this.data.details.message_from_consumer;
    
    if ( ret === null || ret === undefined )
        return default_value;
    
    return ret;
}



Task.prototype.getRoleCodes = function()
{
    return this.data.details.role_codes;
}

Task.prototype.getState = function()
{
    return this.data.state;
}

Task.prototype.isOpen = function()
{
    return this.getState() === 'open';
}

Task.prototype.isClaimed = function()
{
    return this.getState() === 'claimed';
}

Task.prototype.isComplete = function()
{
    return this.getState() === 'complete';
}

module.exports = Task;

/*

{
    "id" : "00000000-0000-0000-0000-000000000000",
    "account_id" : "00000000-0000-0000-0000-000000000001",
    "details" : {
        "type" : "standard-contact-customer",
        "consumer_name" : "Jim Kane",
        "consumer_endpoint" : "E164:+13152123517",
        "role_codes" : [ "builtin:sales" ]
    },
    "events" : [ {
        "type" : "event-open",
        "event_time" : 1591819133205
    } ],
    "state" : "open",
    "time_open" : 1591819133205
};

*/